export class ContactAddressParameterDto {
  inCareOf: string;
  address1: string;
  address2: string;
  address3: string;
  countryCode: string;
  stateCode: string;
  city: string;
  zip: string;
}
